import Vue from 'vue';
import VueCompositionApi, { reactive } from '@vue/composition-api';

import { Stateful } from './common';

Vue.use(VueCompositionApi);

export type GlobalState = {
  unityRPCLog: string[];
  webViewRPCLog: string[];
};

export type GlobalModel = Stateful<GlobalState> & {
  type: 'GlobalModel';
  logUnityRPCMessage(message: string): void;
  logWebViewRPCMessage(message: string): void;
  clearLogs(): void;
};

export const DefaultGlobalState: GlobalState = {
  unityRPCLog: [],
  webViewRPCLog: [],
};

export function createGlobalModel(state = DefaultGlobalState): GlobalModel {
  // deep copy trick with json serialization
  const _state: GlobalState = reactive(JSON.parse(JSON.stringify(state)));
  function logUnityRPCMessage(message: string) {
    _state.unityRPCLog.push(`[${Date()}] ${message}`);
  }
  function logWebViewRPCMessage(message: string) {
    _state.unityRPCLog.push(`[${Date()}] ${message}`);
  }

  function clearLogs() {
    _state.unityRPCLog.length = 0;
    _state.webViewRPCLog.length = 0;
    _state.unityRPCLog = [];
    _state.webViewRPCLog = [];
  }
  return {
    type: 'GlobalModel',
    state: _state,
    logUnityRPCMessage,
    logWebViewRPCMessage,
    clearLogs,
  };
}
